/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business 権限外ページアクセス時の 403 案内画面。ホームへの導線を提供する。
 * @graph-connects none
 */

import { Link } from '@tanstack/react-router';
import { ShieldX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card } from '@cortex/web-design-system/components/ui/Card';
import { Button } from '@cortex/web-design-system/components/ui/Button';

/** @graph-connects none */
export function ForbiddenPage() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto w-full max-w-lg px-4 py-20">
      <Card className="p-10 text-center">
        <ShieldX
          className="mx-auto mb-4 h-12 w-12 text-[var(--color-text-muted)]"
          aria-hidden="true"
        />
        <h1 className="mb-2 text-lg font-bold text-[var(--color-text-primary)]">
          {t('forbidden.title')}
        </h1>
        <p className="mb-6 text-sm text-[var(--color-text-secondary)]">
          {t('forbidden.description')}
        </p>
        <Link to="/">
          <Button variant="primary">{t('forbidden.backToHome')}</Button>
        </Link>
      </Card>
    </div>
  );
}
